document.addEventListener('teeinblue-event-after-cart-added', function () {
  // Show popup confirm
  const modal = document.getElementById('tee_add_to_cart_confirm');
  modal.style.display = 'block';

  const confirmButtons = modal.querySelector('[data-confirm-modal]');
  const closeButtons = modal.querySelectorAll('[data-close-modal]');
  const imageContainer = modal.querySelector('.confirm-modal--image');
  const optionsContainer = modal.querySelector('.confirm-modal--options');
  imageContainer.innerHTML =
    '<span class="tee-spinner tee-spinner--sm"><svg xmlns="http://www.w3.org/2000/svg" version="1.0" viewBox="0 0 128 128" class="tee-icon-loading tee-icon-loading--sm"><g><path d="M64 127.75A63.76 63.76 0 0152.8 1.23v14.23a49.8 49.8 0 1022.4 0V1.23A63.76 63.76 0 0164 127.75z"></path><animateTransform attributeName="transform" type="rotate" from="0 64 64" to="360 64 64" dur="1260ms" repeatCount="indefinite"></animateTransform></g></svg></span>';

  closeButtons.forEach((button) => {
    button.addEventListener('click', () => (modal.style.display = 'none'));
  });
  confirmButtons.addEventListener('click', () => {
    // navigate to cart page
    window.location.href = '/cart';
  });

  // Get cart data
  const request = new XMLHttpRequest();

  request.open('GET', '/cart.js', true);
  request.onload = function () {
    if (this.status >= 200 && this.status < 400) {
      const data = JSON.parse(this.response);
      const itemCount = data.item_count;
      const cartCount = document.querySelectorAll('.cart_count');

      // Update cart quantity
      if (cartCount.length && itemCount > 0) {
        cartCount.forEach(function (cart) {
          cart.innerHTML = `<span class="cart_count">${itemCount}</span>`;
        });
      } else {
        cartCount.forEach(function (cart) {
          cart.innerHTML = '<span class="cart_count"></span>';
        });
      }

      const customizeImage = data.items[0].properties._customization_image;
      const optionsWithValues = data.items[0].options_with_values;
      // Update image
      if (customizeImage) {
        const img = new Image();
        img.src = customizeImage;
        img.alt = 'Customize Image';
        img.width = 170;
        img.height = 170;
        // onload function ensures the image is fully loaded before displaying
        img.onload = function () {
          imageContainer.innerHTML = '';
          imageContainer.appendChild(img);
        };
        img.onerror = function () {
          console.error('Failed to load image:', customizeImage);
        };
      }
      // Update options
      if (optionsWithValues) {
        optionsContainer.innerHTML = '';
        optionsWithValues.forEach(function (option) {
          optionsContainer.innerHTML += `<div>${option.name}: ${option.value}</div>`;
        });
      }
    }
  };
  request.send();
});
